import * as React from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 6, viewBox: "0 0 6 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 3, cy: 3, r: 3, fill: "#9A00FF", fillOpacity: 0.5 }));
export default SvgDot;
